/**
 * i18n Configuration - YUL ON TAP
 * 
 * Phase 3: Bilingual support (English + French)
 * - Admin UI localization
 * - Guest-facing flow localization
 * - Export header localization
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'yul_language',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    // Return key if translation missing (helps identify gaps)
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
